import { OrderCategory, QuoteProductLeg } from "../../api/endpoints/Order";
import {
  DEFAULT_PRODUCT_FORM_VALUES,
  IProductFormValues
} from "../../components/RealtimeProductConfigurator/ProductForm";
import { compact, flatten, isUndefined } from "lodash";
import { formatBaseTime, formatDirection, formatFrequency } from "../Format";
import { sortNumericStrings } from "../Array";
import { TOrderProductData } from "../../api/endpoints/OrderProduct";

const deriveStepsFromLeg = (leg: QuoteProductLeg): Array<string> => {
  const step = leg.step;

  return step ? sortNumericStrings(step) : [];
}

const extractLegsFromProduct = (product: TOrderProductData<OrderCategory.REALTIME>): Array<QuoteProductLeg> => {
  const { legs } = product;

  return legs ?? [];
}

const productToValues = (product: TOrderProductData<OrderCategory.REALTIME> | null): IProductFormValues => {
  const values: IProductFormValues = { ...DEFAULT_PRODUCT_FORM_VALUES };

  if (product) {
    const legs: Array<QuoteProductLeg> = extractLegsFromProduct(product);

    values.name = product.name;

    if (legs.length) {
      values.steps = flatten(legs.map(deriveStepsFromLeg));
      values.grid = compact(legs.map(l => l.grid));
    }

    if (product.grid) {
      values.grid = [product.grid];
    }

    if (product.step) {
      values.steps = product.step;
    }

    if (product.number) {
      values.number = product.number;
    }

    if (product.area) {
      values.areas = product.area;
    }

    if (product.use) {
      values.use = product.use.map(v => v.toString());
    }

    if (product.hindcast) {
      values.hindcast = product.hindcast.map(v => v.toString());
    }

    if (product.fcmonth) {
      values.fcmonth = product.fcmonth;
    }

    if (product.param) {
      values.param = product.param;
    }

    if (product.levelist) {
      values.levelist = product.levelist;
    }

    if (product.param_levelist) {
      values.param_levelist = product.param_levelist.map(p => ({
        param: p.param,
        level: p.level.toString()
      }));
    }

    if (product.param_quantile) {
      values.param_quantile = product.param_quantile;
    }

    if (product.time) {
      values.time = product.time.map(formatBaseTime);
    }

    if (product.time_step) {
      values.time_step = product.time_step;
    }

    if (product.use_step) {
      values.use_step = product.use_step;
    }

    if (product.location) {
      values.location = product.location;
    }

    if (product.channel) {
      values.channel = product.channel
    }

    if (product.direction) {
      values.direction = product.direction.map(formatDirection);
    }

    if (product.frequency) {
      values.frequency = product.frequency.map(formatFrequency);
    }
  }

  return values;
}

export default productToValues;
